export class WebFormStackVariableString extends DevBX.MSLang.StackVariable {

    constructor(isConst, formField) {
        super(DevBX.MSLang.VariableType.vtString, isConst);

        this._formField = formField;
    }

    get functions() {
        return DevBX.MSLang.StackVariableString.prototype.functions;
    }

    get value() {
        return this._formField.value;
    }

    set value(value) {
        if (typeof value !== 'string')
            throw new Error('variable type ' + typeof value + ' expected string')

        this._formField.value = value;
    }
}

export class WebFormStackVariableArray extends DevBX.MSLang.StackVariable {

    constructor(isConst, formField) {
        super(DevBX.MSLang.VariableType.vtArray, isConst);

        this._formField = formField;
    }

    get functions() {
        return DevBX.MSLang.StackVariableArray.prototype.functions;
    }

    get value() {
        return this._formField.value;
    }

    set value(value) {
        if (!Array.isArray(value))
            throw new Error('variable type ' + typeof value + ' expected array')

        this._formField.value = value;
    }
}

export class WebFormStackVariableDateTimeObject extends DevBX.MSLang.StackVariableDateTimeObject {
    constructor(formField) {
        super(null);

        this._formField = formField;
    }

    get value() {
        return this._formField.value;
    }
}

export class WebFormStackVariableBoolean extends DevBX.MSLang.StackVariable {
    constructor(formField) {
        super(DevBX.MSLang.VariableType.vtBoolean, true);

        this._formField = formField;
    }

    get value() {
        return this._formField.value;
    }
}

export class WebFormStackVariableNumber extends DevBX.MSLang.StackVariable {
    constructor(formField) {
        super(DevBX.MSLang.VariableType.vtNumber, true);

        this._formField = formField;
    }

    get value() {
        if (typeof this._formField.value !== 'number')
            return null;

        return this._formField.value;
    }
}

export class WebFormStackVariableFieldsObject extends DevBX.MSLang.StackVariable {
    constructor(formFields) {
        super(DevBX.MSLang.VariableType.vtObject, true);

        this._formFields = formFields;
    }

    getProperty(name) {
        let formField = undefined;

        this._formFields.every(search => {
            if (search.name !== name)
                return true;

            formField = search;

            return false;
        });

        if (!formField)
            return undefined;

        switch (formField.type) {
            case 'string':
                return new WebFormStackVariableString(true, formField);
            case 'array':
            case 'files':
                return new WebFormStackVariableArray(true, formField);
            case 'object':
                return new WebFormStackVariableFieldsObject(formField.value);
            case 'datetime':
            case 'date':
            case 'time':
                return new WebFormStackVariableDateTimeObject(formField)
            case 'boolean':
                return new WebFormStackVariableBoolean(formField);
            case 'number':
                return new WebFormStackVariableNumber(formField);
        }

        return undefined;
    }
}
